
(function () {
  const STORAGE_KEY = 'dawn:collection:view';
  // Set to true to always open Grid on page load/refresh (ignores saved value on load).
  // Set to false to respect previously saved choice in localStorage.
  const FORCE_GRID_ON_LOAD = true;

  function applyViewToGrid(gridEl, view) {
    if (!gridEl) return;
    if (view === 'list') gridEl.classList.add('collection-view-list');
    else gridEl.classList.remove('collection-view-list');
  }

  function setButtonsState(switchEl, view) {
    if (!switchEl) return;
    switchEl.querySelectorAll('.collection-view-btn').forEach(btn => {
      const active = btn.dataset.view === view;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  function findGridForSwitch(switchEl) {
    // Prefer a .product-grid inside the same section (so multiple sections work independently)
    const sectionRoot = switchEl.closest('section') || document;
    return sectionRoot.querySelector('.product-grid') || document.querySelector('.product-grid');
  }

  function initSwitch(switchEl) {
    if (!switchEl || switchEl.dataset.inited === 'true') return;

    const gridEl = findGridForSwitch(switchEl);
    if (!gridEl) {
      // If the grid isn't present yet (AJAX render), observe the section and retry when .product-grid appears.
      const sectionRoot = switchEl.closest('section') || document;
      const mo = new MutationObserver((mutations, observer) => {
        if (sectionRoot.querySelector && sectionRoot.querySelector('.product-grid')) {
          observer.disconnect();
          // re-run init for this switch once grid exists
          initSwitch(switchEl);
        }
      });
      mo.observe(sectionRoot, { childList: true, subtree: true });
      return;
    }

    // Load saved view (unless forced to grid on load)
    let saved = 'grid';
    try {
      if (!FORCE_GRID_ON_LOAD) {
        saved = localStorage.getItem(STORAGE_KEY) || 'grid';
      } else {
        // ensure the saved string remains for click persistence, but we still show grid on load
        saved = 'grid';
      }
    } catch (e) {
      saved = 'grid';
    }

    applyViewToGrid(gridEl, saved);
    setButtonsState(switchEl, saved);

    // Attach click handlers (saves the user's selection)
    switchEl.querySelectorAll('.collection-view-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        const view = (btn.dataset.view === 'list') ? 'list' : 'grid';
        applyViewToGrid(gridEl, view);
        setButtonsState(switchEl, view);
        try { localStorage.setItem(STORAGE_KEY, view); } catch (e) {}
      });
    });

    switchEl.dataset.inited = 'true';
  }

  function initAll(root = document) {
    const switches = root.querySelectorAll ? root.querySelectorAll('[data-collection-view-switch]') : [];
    switches.forEach(initSwitch);
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', () => initAll(document));

  // Re-init when Shopify sections re-render
  document.addEventListener('shopify:section:load', (e) => initAll(e.target || document));
  document.addEventListener('facets:updated', () => initAll(document));

  // As a final enforcement after everything loads, make sure grid is active on refresh when FORCE_GRID_ON_LOAD
  if (FORCE_GRID_ON_LOAD) {
    window.addEventListener('load', () => {
      document.querySelectorAll('.product-grid').forEach(g => {
        g.classList.remove('collection-view-list');
      });
      // Update any visible switcher buttons to grid active
      document.querySelectorAll('[data-collection-view-switch]').forEach(s => setButtonsState(s, 'grid'));
    });
  }

  // MutationObserver fallback: re-init if switches or product-grids are dynamically added
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && (node.matches('.product-grid') || node.matches('[data-collection-view-switch]')) ||
            (node.querySelector && (node.querySelector('.product-grid') || node.querySelector('[data-collection-view-switch]')))) {
          initAll(document);
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function closeCardQuickAdd(container) {
    container.classList.remove('active');
    const button = container.querySelector('.quick-add-btn');
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.quick-add-btn');
    if (!button) {
      if (!event.target.closest('.quick-add-wrapper')) {
        document.querySelectorAll('.quick-add-wrapper.active').forEach(closeCardQuickAdd);
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const container = button.closest('.quick-add-wrapper');
    if (!container) return;

    const willOpen = !container.classList.contains('active');
    document.querySelectorAll('.quick-add-wrapper.active').forEach(closeCardQuickAdd);

    if (willOpen) {
      container.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.quick-add-wrapper.active').forEach(closeCardQuickAdd);
  });
})();

(function () {
  const MOBILE_BREAKPOINT = '(max-width: 768px)';

  function findCurrentFeature(items, currentHandle) {
    const currentPath = window.location.pathname.replace(/\/$/, '');

    return items.find((item) => {
      try {
        return new URL(item.href, window.location.origin).pathname.replace(/\/$/, '') === currentPath;
      } catch (error) {
        return false;
      }
    }) || items.find((item) => item.dataset.collectionHandle === currentHandle)
      || items.find((item) => item.matches('[aria-current="page"], .feature-grid__item--current'));
  }

  function revealCurrentFeature(section) {
    if (!window.matchMedia(MOBILE_BREAKPOINT).matches) return;

    const wrapper = section.querySelector('[data-feature-grid-wrapper]');
    const items = Array.from(section.querySelectorAll('.feature-grid__item'));
    const currentItem = findCurrentFeature(items, section.dataset.currentCollectionHandle);
    if (!wrapper || !currentItem) return;

    items.forEach((item) => {
      const isCurrent = item === currentItem;
      item.classList.toggle('feature-grid__item--current', isCurrent);

      if (isCurrent) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });

    const scrollSnapType = wrapper.style.scrollSnapType;
    wrapper.style.scrollSnapType = 'none';
    currentItem.scrollIntoView({
      behavior: 'auto',
      block: 'nearest',
      inline: 'center'
    });

    window.requestAnimationFrame(() => {
      wrapper.style.scrollSnapType = scrollSnapType;
    });
  }

  function initFeatureGrids(root) {
    const sections = [];

    if (root.matches && root.matches('.feature-grid[data-current-collection-handle]')) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(...root.querySelectorAll('.feature-grid[data-current-collection-handle]'));
    }

    sections.forEach((section) => {
      [0, 100, 350, 800].forEach((delay) => {
        window.setTimeout(() => revealCurrentFeature(section), delay);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initFeatureGrids(document));
  document.addEventListener('shopify:section:load', (event) => initFeatureGrids(event.target));
  window.addEventListener('pageshow', () => initFeatureGrids(document));
})();

(function () {
  const canHoverVideo = window.matchMedia('(hover: hover) and (min-width: 990px)');

  document.addEventListener('mouseover', (event) => {
    if (!canHoverVideo.matches || !(event.target instanceof Element)) return;
    const card = event.target.closest('.card-wrapper');
    const video = card && card.querySelector('video.card__hover-video');
    if (!video || !video.paused) return;
    if (!video.dataset.hoverBound) {
      video.dataset.hoverBound = 'true';
      video.addEventListener('playing', () => video.classList.add('card__hover-video--ready'));
    }
    video.play().catch(() => {});
  });

  document.addEventListener('mouseout', (event) => {
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;
    const video = card.querySelector('video.card__hover-video');
    if (!video) return;
    video.pause();
    video.classList.remove('card__hover-video--ready');
  });
})();
